//#region src/version.ts
const CATALOG_VERSION = 2;
//#endregion
export { CATALOG_VERSION };

//# sourceMappingURL=version.js.map